<script>
	const poll = require('modules/poll');
	module.exports = {
		components: {
			'load-mask': require('components/load-mask.vue').default
		},
		props: {
			formId: {
				required: true
			}
		},
		data() {
			return {
				loading: false
			};
		},
		methods: {
			clearKindful() {
				let success = false;
				let container = this.$refs.kindfulContainer;
				if (container) {
					$('script[src*="readworksinc-bloom.kindful.com"]').remove();
					if (window.kindfulWidget && window.kindfulChildWindow) {
						delete window.kindfulWidget;
						delete window.kindfulChildWindow;
					}
					$(container).empty();
					success = true;
				}
				return success;
			},
			loadKindful(id) {
				let container = this.$refs.kindfulContainer;
				if (container && id) {
					this.loading = true;
					let formContainerId = `kindful-donate-form-${id}`;
					let formElement = document.createElement('div');
					formElement.classList.add('kindful-embed-wrapper');
					formElement.setAttribute('id', formContainerId);
					container.appendChild(formElement);

					let scriptTag = document.createElement('script');
					scriptTag.async = 1;
					scriptTag.src = `https://readworksinc-bloom.kindful.com/embeds/${id}/init.js?type=form`;
					scriptTag.setAttribute('data-embed-id', id);
					scriptTag.setAttribute('data-lookup-type', 'jquery-selector');
					scriptTag.setAttribute('data-lookup-value', `#kindful-donate-form-${id}`);
					container.appendChild(scriptTag);
					poll(() => {
						let success = false;
						let iframe = document.querySelector(`#${formContainerId} > iframe`);

						if (iframe) {
							let timeoutId = null;
							const doneLoading = () => {
								this.loading = false;
								iframe.removeEventListener('load', doneLoading);
								clearTimeout(timeoutId);
							};

							iframe.addEventListener('load', doneLoading);
							timeoutId = setTimeout(doneLoading, 5000);
							success = true;
						}
						return success;
					});
				}
			}
		},
		beforeDestroy() {
			this.clearKindful();
		},
		watch: {
			formId(id, oldId) {
				if (id && id !== oldId) {
					if (this.clearKindful()) {
						this.loadKindful(id);
					}
				}
			}
		},
		mounted() {
			this.loadKindful(this.formId);
		}
	};
</script>
<style lang="scss">
	.kindful {
		position: relative;
		margin-top: 0.5rem;

		.kindful-embed-wrapper {
			height: 800px !important;
			width: 100% !important;

			iframe#kindful-iframe {
				z-index: 0 !important;
			}
		}
	}
</style>
<template>
	<div class="kindful">
		<load-mask v-if="loading"></load-mask>
		<div v-if="!formId">No Form ID specified</div>
		<div
			class="kindful-container"
			ref="kindfulContainer"></div>
	</div>
</template>
